import { connect } from 'react-redux'
import { actions } from '../../../store/subcontractorForms'
import { generateListCallbacks } from '../../../store/helpers/listActionsHelpers'

function mapStateToProps(state) {
  return {
    subcontractorForms: state.subcontractorForms,
    subcontractorFormDetail: state.subcontractorForms.subcontractorFormDetail,
    subcontractorFormReplies: state.subcontractorForms.subcontractorFormReplies,
    repliesPending: state.subcontractorForms.repliesPending,
    users: state.subcontractorForms.users,
    filters: state.subcontractorForms.filters,
    authUser: state.auth,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    ...generateListCallbacks(dispatch, actions),
    fetchList: () => dispatch(actions.fetchList()),
    getReplies: params => dispatch(actions.getReplies(params)),
    createReply: params => dispatch(actions.createReply(params)),
    assignUser: params => dispatch(actions.assignUser(params)),
    getStaffUsers: () => dispatch(actions.getStaffUsers()),
    downloadFormPdf: params => dispatch(actions.downloadFormPdf(params)),
    assignFormToStaff: params => dispatch(actions.assignFormToStaff(params)),
    batchUpdateStatus: params => dispatch(actions.batchUpdateStatus(params)),
    updateScore: params => dispatch(actions.updateScore(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
